import React, { useState, useEffect } from 'react';
import { onNetworkStateChange, isOffline } from '../firebase/network';

/**
 * Bandeau affiché en bas de l'écran quand l'utilisateur est hors ligne.
 * Utilise le système de notification réseau déjà présent dans firebase/config.js
 */
export default function OfflineIndicator() {
  const [offline, setOffline] = useState(isOffline());

  useEffect(() => {
    const unsub = onNetworkStateChange((online) => setOffline(!online));
    return unsub;
  }, []);

  if (!offline) return null;

  return (
    <div
      role="alert"
      style={{
        position: 'fixed',
        bottom: 20,
        left: '50%',
        transform: 'translateX(-50%)',
        backgroundColor: '#e65100',
        color: '#fff',
        padding: '10px 24px',
        borderRadius: 24,
        fontWeight: 600,
        fontSize: 14,
        zIndex: 10000,
        boxShadow: '0 4px 12px rgba(0,0,0,0.35)',
        display: 'flex',
        alignItems: 'center',
        gap: 8,
        whiteSpace: 'nowrap',
      }}
    >
      <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
        <path d="M1 1l22 22M16.72 11.06A10.94 10.94 0 0 1 19 12.55M5 12.55a10.94 10.94 0 0 1 5.17-2.39M10.71 5.05A16 16 0 0 1 22.56 9M1.42 9a15.91 15.91 0 0 1 4.7-2.88M8.53 16.11a6 6 0 0 1 6.95 0M12 20h.01" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" fill="none"/>
      </svg>
      Mode hors ligne — les opérations seront synchronisées au retour
    </div>
  );
}
